import { Route, Switch, Redirect } from "react-router-dom";
import Models from "../screens/Models";
import Users from "../screens/Users";
import Tools from "../screens/Tools";
import Discount from "../screens/Discount";
import Currency from "../screens/Currency";
import Reports from "../screens/Reports";
import Main from "../screens/Main";
import SalesOfficeLevel from "../screens/SalesOfficeLevel";
import SalesOffice from "../screens/SalesOffice";
import SalesUsers from "../screens/SalesUsers";
import ToolsOffered from "../screens/ToolsOffered";
import DiscountsOffered from "../screens/DiscountsOffered";
import Customers from "../screens/Customers";
import { useParams } from "react-router-dom";
import Markets from "../screens/Markets";
import PageNotFound from "../hooks/pageNotFound";

const AppRoutes = ({selectedTab,userInfo}) => {
    console.log("routes role",userInfo);
    const { passSalesOfficeId } = useParams();
    if(userInfo?.userRole === "ADMIN"){
        return (
            <Switch>
                <Route 
                    exact 
                    path="/licenseManager" 
                >
                    <Redirect to="/licenseManager/admin/regions" />
                </Route>    
                <Route 
                    exact 
                    path="/licenseManager/admin/regions" 
                    render={(props) =>(
                        <Models {...props} selectedTab={selectedTab} />
                    )}
                />
                <Route 
                    exact 
                    path="/licenseManager/admin/users"
                    render={(props) => (
                        <Users {...props} selectedTab={selectedTab}/>
                    )} 
                />
                <Route 
                    exact 
                    path="/licenseManager/admin/tools" 
                    render={(props) => (
                        <Tools {...props} selectedTab={selectedTab}/>
                    )}
                />
                <Route 
                    exact 
                    path="/licenseManager/admin/discounts"
                    render={(props) => (
                        <Discount {...props} selectedTab={selectedTab}/>
                    )} 
                />
                <Route 
                    exact  
                    path="/licenseManager/admin/currency"
                    render={(props) => (
                        <Currency {...props} selectedTab={selectedTab}/>
                    )} 
                />
                <Route 
                    exact 
                    path="/licenseManager/admin/reports" 
                    render={(props) => (
                        <Reports {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                {/* <Route
                    exact
                    path="/region/regionsLevel/:id"
                >
                    <Redirect to={`/region/regionsLevel/${userInfo?.userId}`} />
                </Route> */}
                <Route
                    exact
                    path="/licenseManager/region/regionsLevel/:id"
                    render={(props) => (
                        <SalesOfficeLevel {...props} selectedTab={selectedTab} regionId={userInfo?.userId}/>
                    )}
                />
                {/* <Route
                    exact
                    path="/region/regionsLevel/:id"
                >
                    <Redirect to={`/region/regionsLevel/${userInfo.userId}`} />
                </Route> */}
                <Route
                    exact
                    path="/licenseManager/region/regionsLevel/:id"
                    render={(props) => (
                        <SalesOffice {...props} selectedTab={selectedTab} regionId={userInfo?.userId}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/region/regionsUsers/:id"
                    render={(props) => (
                        <SalesUsers {...props} selectedTab={selectedTab} />
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/region/reports/:id"
                    render={(props) => (
                        <Reports {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager"
                >
                    <Redirect to={`/licenseManager/office/customers/${userInfo?.userId}`} />
                </Route>
                <Route
                    exact
                    path="/licenseManager/office/customers/:passBySalesOfficeId"
                    render={(props) => (
                        <Customers {...props} selectedTab={selectedTab} userInfo={userInfo?.userId}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/markets/:id"
                    render={(props) => (
                        <Markets {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                    <Route
                        exact
                        path="/licenseManager/office/reports/:id"
                        render={(props) => (
                            <Reports {...props} selectedTab={selectedTab}  userInfo={userInfo}/>
                        )}
                    /> 
                <Route
                    exact
                    path="/licenseManager/office/toolsOffered/:id"
                    render={(props) => (
                        <ToolsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/discountsOffered/:id"
                    render={(props) => (
                        <DiscountsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                /> 
            </Switch>
        )
    }
    else if(userInfo?.userRole === "REGION" && userInfo?.userId != null){
        return(
            <Switch>
                <Route
                    exact
                    path="/licenseManager"
                >
                    <Redirect to={`/licenseManager/region/regionsLevel/${userInfo?.userId}`} />
                </Route>
                <Route
                    exact
                    path="/licenseManager/region/regionsLevel/:id"
                    render={(props) => (
                        <SalesOfficeLevel {...props} selectedTab={selectedTab} regionId={userInfo?.userId}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/region/regionsLevel/:id"
                    render={(props) => (
                        <SalesOffice {...props} selectedTab={selectedTab} regionId={userInfo?.userId}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/region/regionsUsers/:id"
                    render={(props) => (
                        <SalesUsers {...props} selectedTab={selectedTab} regionId={userInfo?.userId}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/region/reports/:id"
                    render={(props) => (
                        <Reports {...props} selectedTab={selectedTab}  userInfo={userInfo}/>
                    )}
                /> 
                <Route
                    exact
                    path="/licenseManager/office/customers/:id"
                    render={(props) => (
                        <Customers {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/reports/:id"
                    render={(props) => (
                        <Reports {...props} selectedTab={selectedTab}  userInfo={userInfo}/>
                    )}
                /> 
                <Route
                    exact
                    path="/licenseManager/office/markets/:id"
                    render={(props) => (
                        <Markets {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/toolsOffered/:id"
                    render={(props) => (
                        <ToolsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/discountsOffered/:id"
                    render={(props) => (
                        <DiscountsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
            </Switch>
        )
    }
    else if(userInfo?.userRole === "SALES_OFFICE" && userInfo?.userId != null){
        return(
            <Switch>
                <Route
                    exact
                    path="/licenseManager"
                >
                    <Redirect to={`/licenseManager/office/customers/${userInfo?.userId}`}/>
                </Route>
                <Route
                    exact
                    path="/licenseManager/office/customers/:id"
                    render={(props) => (
                        <Customers {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/reports/:id"
                    render={(props) => (
                        <Reports {...props} selectedTab={selectedTab}  userInfo={userInfo}/>
                    )}
                /> 
                <Route
                    exact
                    path="/licenseManager/office/markets/:id"
                    render={(props) => (
                        <Markets {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/toolsOffered/:id"
                    render={(props) => (
                        <ToolsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
                <Route
                    exact
                    path="/licenseManager/office/discountsOffered/:id"
                    render={(props) => (
                        <DiscountsOffered {...props} selectedTab={selectedTab} userInfo={userInfo}/>
                    )}
                />
            </Switch>
        )
    }
    else if(userInfo?.userRole === "" || userInfo?.userId === null || userInfo?.userRole?.response == undefined){
        return <Route path='*' render={(props) => (<PageNotFound {...props} />) } />
    }
    else{
        return <Redirect to="/licenseManager" />  
    }
}

export default AppRoutes;